import {
  ApiClient,
  type SaveSystemSettingsRequest,
  type SystemSettingItemDto,
} from "../../types/domainobjects";
import type { SystemSetting } from "../types/system-setting";
import type { SystemSettingValueType } from "../types/system-setting-value-type";

const apiClient = new ApiClient();

const toValueType = (rawValueType: unknown): SystemSettingValueType => {
  if (typeof rawValueType === "string") {
    const lowered = rawValueType.toLowerCase();
    if (
      lowered === "string" ||
      lowered === "int" ||
      lowered === "bool" ||
      lowered === "dropdown"
    ) {
      return lowered;
    }
  }

  if (typeof rawValueType === "number") {
    if (rawValueType === 1) {
      return "int";
    }
    if (rawValueType === 2) {
      return "bool";
    }
    if (rawValueType === 3) {
      return "dropdown";
    }
  }

  return "string";
};

export const getSystemSettings = async (): Promise<SystemSetting[]> => {
  const response = await apiClient.systemSettings_Get();
  return (response ?? []).map((item) => {
    const typedItem = item as SystemSettingItemDto & { valueType?: unknown };
    return {
      identifier: item.identifier ?? "",
      value: item.value ?? null,
      valueType: toValueType(typedItem.valueType),
    };
  });
};

export const saveSystemSettings = async (
  settings: SystemSetting[],
): Promise<void> => {
  const request: SaveSystemSettingsRequest = {
    settings: settings.map((setting) => ({
      identifier: setting.identifier,
      value: setting.value,
    })),
  };

  await apiClient.systemSettings_SaveAll(request);
};
